import React from 'react';
import Loader from 'utils/Loader';
import { useLocation } from 'react-router-dom';
import {
    Box,
    Button,
    Grid,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    FormHelperText
} from '@mui/material';
import BeatCustomersController from '../Controller/BeatCustomersController';
import { People, Apartment, Close } from '@mui/icons-material';

const BeatCustomers = () => {
    const {
        user,
        selectedDate,
        isPastDate,
        cloading,
        customerCount,
        route,
        beatCustomers,
        openStatusModal,
        toggleStatusModal,
        remark,
        changeRemark,
        showCustomerReports,
        sendVisitRemark,
        plantOptions,
        selectedPlant,
        handlePlantChange,
        isPlantVisit,
        plantError
    } = BeatCustomersController();

    const location = useLocation();
    const beatCode = location.state?.beatCode;

    return (
        <>
            <div className="bg" style={{ display: 'block' }}>
                {cloading && (
                    <div className="overlay">
                        <Loader />
                        <span style={{ marginLeft: '10px' }}>Please Wait....</span>
                    </div>
                )}

                <div className="cutrange">
                    <span className="font20" style={{ fontWeight: 'bold' }}>BEAT Customers</span>
                </div>

                <Grid container fullWidth pb={2}>
                    <Grid item xs={6}>
                        <Paper sx={{ backgroundColor: 'white', borderRadius: '10px', padding: '5px', width: 'fit-content' }}>
                            <span style={{ color: 'black', fontWeight: 'bold' }}>{selectedDate}</span>
                        </Paper>
                    </Grid>

                    <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Paper sx={{ backgroundColor: 'white', borderRadius: '10px', padding: '5px', width: 'fit-content' }}>
                            <span style={{ color: 'black', fontWeight: 'bold' }}>Route Code: {beatCode}</span>
                        </Paper>
                    </Grid>
                </Grid>

                <Box py={2}>
                    <span style={{ color: 'white', fontWeight: 'bold' }}>{customerCount} Customers: {route}</span>
                </Box>

                <div>
                    {beatCustomers.length === 0 && (
                        <Box fullWidth sx={{ textAlign: 'center' }}>
                            <span>No Customers Assigned!</span>
                        </Box>
                    )}

                    <Box fullWidth pb={2}>
                        <Grid container spacing={3}>
                            {beatCustomers.map((customer, index) => (
                                <Grid item xs={12} sm={6} md={4} xl={4} key={index}>
                                    <Box sx={{ backgroundColor: 'white', borderRadius: '10px', boxSizing: 'border-box', px: 2, py: 1 }}>
                                        <div style={{ width: '100%' }}>
                                            <span style={{ color: 'black', display: 'block', paddingBottom: '1rem', fontWeight: 'bold' }}>
                                                <People /> {customer.partyName}
                                            </span>
                                            <span style={{ color: 'black', display: 'block', paddingBottom: '1rem', fontWeight: 'bold' }}>
                                                <Apartment /> {customer.city}
                                            </span>
                                        </div>

                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Button
                                                    sx={{
                                                        color: 'black',
                                                        backgroundColor: 'lightgrey',
                                                        '&:hover': { backgroundColor: 'darkgrey' },
                                                    }}
                                                    onClick={() => showCustomerReports(customer)}
                                                >
                                                    Reports
                                                </Button>
                                            </Grid>

                                            <Grid item xs={6}>
                                                <Button
                                                    sx={{
                                                        color: 'black',
                                                        backgroundColor: 'lightblue',
                                                        '&:hover': { backgroundColor: 'skyblue' },
                                                        '&.Mui-disabled': {
                                                            color: 'black',
                                                            backgroundColor: 'lightblue'
                                                        }
                                                    }}
                                                    onClick={() => toggleStatusModal(customer, false, 'customer')}
                                                    disabled={isPastDate}
                                                >
                                                    Status
                                                </Button>
                                            </Grid>
                                        </Grid>

                                        {/* DIST user extra options */}
                                        {(user.userTypeId === 'DIST' || user.userTypeId === 'ALL') && (
                                            <Grid container spacing={2} mt={1}>
                                                {['New Retailer', 'Dealer', 'Plant Visit'].map((label, idx) => {
                                                    let type = '';
                                                    if (label === 'New Retailer') type = 'retailer';
                                                    else if (label === 'Dealer') type = 'dealer';
                                                    else if (label === 'Plant Visit') type = 'PlantVisit';

                                                    return (
                                                        <Grid item xs={4} key={idx}>
                                                            <button
                                                                style={{
                                                                    width: '100%',
                                                                    border: 'none',
                                                                    padding: '10px 0',
                                                                    borderRadius: '5px',
                                                                    cursor: 'pointer',
                                                                }}
                                                                onClick={() =>
                                                                    toggleStatusModal(customer, label === 'Plant Visit', type)
                                                                }
                                                            >
                                                                {label}
                                                            </button>
                                                        </Grid>
                                                    );
                                                })}
                                            </Grid>
                                        )}
                                    </Box>
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                </div>
            </div>

            {/* Status update dialog */}
            <Dialog
                open={openStatusModal}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        toggleStatusModal();
                    }
                }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle
                    sx={{
                        width: '100%',
                        fontWeight: 'bold',
                        fontSize: '1.5rem',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 0,
                    }}
                >
                    Remarks
                    <Close onClick={() => toggleStatusModal()} />
                </DialogTitle>

                <DialogContent dividers>
                    {/* Plant dropdown for plant visit */}
                    {isPlantVisit && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="plant-label">Select Plant</InputLabel>
                            <Select
                                labelId="plant-label"
                                isSearchable={true}
                                value={selectedPlant}
                                onChange={handlePlantChange}
                                options={plantOptions}
                            >
                                {plantOptions.map((plant, idx) => (
                                    <MenuItem key={idx} value={plant.value}>
                                        {plant.label}
                                    </MenuItem>
                                ))}
                            </Select>
                            {plantError && <FormHelperText sx={{ color: 'red' }}>Please select a plant</FormHelperText>}
                        </FormControl>
                    )}

                    <textarea
                        type="text"
                        name="remark"
                        value={remark}
                        className="form-control inp_text"
                        id="remark"
                        rows={7}
                        cols={50}
                        onChange={(e) => changeRemark(e.target.value)}
                        placeholder="Write Remark Here..."
                        autoFocus
                    />
                </DialogContent>

                <DialogActions sx={{ justifyContent: 'end', px: 3, py: 2 }}>
                    <Button
                        variant="outlined"
                        sx={{
                            color: 'white !important',
                            backgroundColor: 'black',
                            borderColor: 'black !important',
                            '&:hover': { color: 'white', backgroundColor: 'black !important', borderColor: 'black !important' },
                        }}
                        onClick={() => sendVisitRemark('Visited')}
                    >
                        Visited
                    </Button>
                    {!isPlantVisit && (
                        <Button
                            sx={{
                                color: 'black !important',
                                backgroundColor: 'lightgrey',
                                '&:hover': { color: 'black !important', backgroundColor: 'lightgrey' },
                            }}
                            onClick={() => sendVisitRemark('Order Taken')}
                        >
                            Order Taken
                        </Button>)}
                </DialogActions>
            </Dialog>
        </>
    );
};

export default BeatCustomers;
